import { render } from "./CooKiePage.vue?vue&type=template&id=d7ea52a0"
import script from "./CooKiePage.vue?vue&type=script&lang=js"
export * from "./CooKiePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__